import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'la-content-with-label',
  templateUrl: './content-with-label.component.html',
  styleUrls: ['./content-with-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatTooltipModule],
})
export class ContentWithLabelComponent {
  @Input() label?: string;
  @Input() info = '';
  @Input() icon?: string;
  @Input() iconColor?: string;
  @Output() clicked = new EventEmitter<void>();
}
